import { Box, BoxProps } from '@mui/material';
import React from 'react';
import {
  ELEMENT_CO2_BAR_HEIGHT,
  ELEMENT_COST_BAR_HEIGHT,
} from '@ui/ElementList';
import { SimpleBarChart, ISimpleBarChartProps } from '@ui/BarChart';
import { mergeSx } from '@client/helpers/mui.helpers';

interface ResultsBarChartsProps extends BoxProps {
  co2e: ISimpleBarChartProps['value'];
  co2eMax?: number;
  /** Cost in SEK */
  cost: ISimpleBarChartProps['value'];
  /** Max cost in SEK */
  costMax?: number;
  color?: string;
  co2eHeight?: number;
  costHeight?: number;
  disableCo2e?: boolean;
  disableCost?: boolean;
}

const fullWidthSx = { width: '100%' } as const;
const co2eChartMarginSx = { mb: 1 } as const;

const ResultsBarCharts: React.FC<ResultsBarChartsProps> = ({
  co2e,
  co2eMax,
  cost,
  costMax,
  color,
  co2eHeight = ELEMENT_CO2_BAR_HEIGHT,
  costHeight = ELEMENT_COST_BAR_HEIGHT,
  disableCo2e,
  disableCost,
  ...props
}) => {
  return (
    <Box {...props} sx={mergeSx(fullWidthSx, props.sx)}>
      {!disableCo2e && (
        <Box sx={co2eChartMarginSx}>
          <SimpleBarChart
            color={color}
            height={co2eHeight}
            value={co2e}
            maxValue={co2eMax}
          />
        </Box>
      )}
      <Box
        sx={{
          mb: 1,
        }}
      >
        {!disableCost && (
          <SimpleBarChart
            color="black"
            height={costHeight}
            value={cost}
            maxValue={costMax}
          />
        )}
      </Box>
    </Box>
  );
};

export default ResultsBarCharts;
